import styled from "styled-components";

export const SetPasswordFormStyled = styled.div`
  margin: auto;
  width: 100%;
  .login_header {
    margin-bottom: 16px;
    text-align: center;
    color: ${({ theme }) => theme.COLORS.PURPLE_11};
    font-size: ${({ theme }) => theme.FONT.SIZE.S18};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_SEMIBOLD};
  }
  .sub_title {
    margin-bottom: 24px;
    text-align: center;
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
    color: ${({ theme }) => theme.COLORS.GRAY_2};
  }
  .input_wrap {
    margin-bottom: 15px;
  }
  .otp_row {
    margin-bottom: 5px;
    display: flex;
    align-items: center;
    column-gap: 8px;
    .otp_input_col {
      flex: 1;
    }
    .otp_btn_col {
      flex-shrink: 0;
      width: 130px;
    }
  }
  .otp_detail {
    margin-bottom: 16px;
    text-align: center;
    font-size: ${({ theme }) => theme.FONT.SIZE.S13};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
    color: ${({ theme }) => theme.COLORS.GRAY_1};
  }
  .password_hint {
    margin-bottom: 16px;
    font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
    color: ${({ theme }) => theme.COLORS.GRAY_1};
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.MOBILE}) {
    .login_header {
      font-size: ${({ theme }) => theme.FONT.SIZE.S16};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
    }
  }
`;
